const React = require("react");
const {openPopupWindow} = require("../../../../emitters/popup");
const WrapperWithLoading = require("../../../dumb/WrapperWithLoading");
const Popup = require("../../../dumb/Popup/C");
const {apiAdminTerminalsBind} = require("../../../../api/admin/terminals");
const Select = require('../../../dumb/Select/B');
const {apiAdminMposUsersList} = require("../../../../api/admin/mposUsers");

module.exports = ({id, merchant_id, password, update}) => openPopupWindow((setPopupState, popup, onMount) => {
  const {close} = popup;

  popup.state = {
    ...popup.state,
    loading: true,
    codesList: [{}]
  }

  onMount(() => {
    apiAdminMposUsersList({merchant_id}).then((codesList) => {
      setPopupState({
        codesList: codesList.map(({name, code}) => ({
          code,
          name: `${name} (${code})`
        })),
        credentials: password
      })
    }).catch(() => {
      setPopupState({codesList: []})
    }).finally(() => {
      setPopupState({loading: false})
    });
  })

  return (stateOfPopup) => {
    const {codesList, credentials, loading, clicked} = stateOfPopup;

    const credsInvalid = !credentials;
    const disabled = credsInvalid;

    return (
      <Popup
        caption={`Bind terminal #${id}`}
        onCancel={close}
        disabled={loading || !codesList.length || (clicked && disabled)}
        onSave={() => {
          if (disabled) {
            setPopupState({clicked: true});
            return;
          }

          setPopupState({loading: true});

          apiAdminTerminalsBind({id, credentials})
              .then(() => {
                update();
                close();
              }).finally(() => {
                setPopupState({loading: false});
              });
        }}
      >
        <WrapperWithLoading
          loading={loading}
        >
          <div className="mt20">
            {loading || codesList.length
              ? (
                <div>
                  <Select
                    label="Code"
                    propValue="code"
                    propName="name"
                    items={codesList}
                    value={credentials}
                    onChange={(credentials) => setPopupState({credentials})}
                    error={clicked && credsInvalid}
                  />
                </div>
              ) : (
                <div>
                  No credentials were found
                </div>
              )
            }
          </div>
        </WrapperWithLoading>
      </Popup>
    );
  };
})
